module.exports = __webpack_public_path__ + "vue/img/upload-05.734e9f97.png";